module.exports = __webpack_public_path__ + "static/media/cardinal_empty_red.275b16d1.svg";